import { FC } from "react"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "../../../hooks/useTranslation"
import "./styles.scss"

type Props = {
  title: string
  onClick: () => void
}

export const CreateFooter: FC<Props> = ({ title, onClick }) => {
  const navigate = useNavigate()
  const { p } = useTranslation("general")
  return (
    <div className="create-household-actions">
      <div className="create-household-actions__container">
        <div
          className="create-household-actions__cancel"
          onClick={() => navigate("/households")}
        >
          {p("cancel")}
        </div>
        <div className="create-household-actions__primary" onClick={onClick}>
          {title}
        </div>
      </div>
    </div>
  )
}
